import { __awaiter, __generator } from "tslib";
import { HttpClient } from '@wix/http-client';
import { baseUtils } from '../utils/baseUtils';
import window from '../sdk/windowWrapper';
import AppSettings from './appSettings';
import { experimentsWrapper } from '../sdk/experimentsWrapper';
var httpClient = new HttpClient();
var GallerySettings = /** @class */ (function () {
    function GallerySettings() {
        var _this = this;
        try {
            this.protocol = window.location.protocol;
            this.galleryId = window.galleryId;
            this.instance = window.instance;
        }
        catch (e) {
            this.protocol = 'http:';
            this.galleryId = '';
            this.instance = '';
        }
        this.baseUrl =
            this.protocol +
                '//progallery.wixapps.net/_api/pro-gallery-editor-webapp/v1/gallery/';
        this.getGallerySettingsApi = function () {
            return "".concat(_this.baseUrl).concat(_this.galleryId, "?instance=").concat(_this.instance, "&isStore=").concat(baseUtils.isStoreGallery());
        };
        this.appSettings = new AppSettings();
    }
    GallerySettings.prototype.get = function (key) {
        return httpClient
            .get(this.getGallerySettingsApi(), {
            withCredentials: true,
            xsrfCookieName: null,
        })
            .then(function (_a) {
            var data = _a.data;
            return key ? data.settings[key] : data.settings;
        });
    };
    GallerySettings.prototype.set = function (key, value) {
        var _this = this;
        return this.get().then(function (data) {
            var _a;
            data = data || {};
            var settings = Object.assign(data, (_a = {}, _a[key] = value, _a));
            return httpClient
                .put(_this.getGallerySettingsApi(), { settings: settings }, { withCredentials: true, xsrfCookieName: null })
                .then(function () { return baseUtils.setExternalId(); });
        });
    };
    GallerySettings.prototype.setAppSettings = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.appSettings.set(key, value)];
                    case 2:
                        _a.sent();
                        baseUtils.setExternalId();
                        return [2 /*return*/, Promise.resolve()];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Failed to set ' + key + ' in appSettings: ' + error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.set(key, value);
                        return [2 /*return*/];
                }
            });
        });
    };
    return GallerySettings;
}());
var gallerySettings = new GallerySettings();
export default gallerySettings;
//# sourceMappingURL=gallerySettings.js.map